import { render, staticRenderFns } from "./showGetfree.vue?vue&type=template&id=96e961fe&scoped=true"
import script from "./showGetfree.vue?vue&type=script&lang=js"
export * from "./showGetfree.vue?vue&type=script&lang=js"
import style0 from "./showGetfree.vue?vue&type=style&index=0&id=96e961fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e961fe",
  null
  
)

export default component.exports